import React from "react";
import DefaultHero from "./variants/Default";
import SimpleHero from "./variants/Simple";
import NoImageHero from "./variants/NoImage";
import HubHero from "./variants/Hub";
import ContributorBio from "./variants/ContributorBio";
import BackgroundImage from "./variants/BackgroundImage";
import type { HeroProps } from "./types";
import VerifiedCertificates from "./variants/VerifiedCertificates";
import SmallHero from "./variants/SmallHero";

const Hero = (props: HeroProps) => {
  const { variant = "default" } = props;
  switch (variant) {
    case "simple":
      return <SimpleHero {...props} />;
    case "no-image":
      return <NoImageHero {...props} />;
    case "bg-image":
      return <BackgroundImage {...props} />;
    case "verified-certificate":
      return <VerifiedCertificates {...props} />;
    case "hub":
      return <HubHero {...props} />;
    case "small-hero":
      return <SmallHero {...props} />;
    case "contributor":
      return <ContributorBio {...props} />;
    default:
      return <DefaultHero {...props} />;
  }
};

export default Hero;
